import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { countryRateTableEntriesOutput } from "./country-rate-table-entries";

export const deleteDefaultCountryRateTable = {
  name: "deleteDefaultCountryRateTable" as const,
  input: z.object({ id: zExt.objectId() }),
  output: countryRateTableEntriesOutput,
};
